<template>
    <modal
        :active="active"
        @closed="$emit('closed', true)"
        :title="title"
        :large="true"
    >
        <ItemSubcategories
            :item-category="itemCategory"
            :updating-sub-sub-category="true"
            @updated="$emit('subcategories-updated')"
            @edit-subcategories="onEditSubcategories"
        />
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputText, InputCheckbox, InputTextarea, InputDropzone} from '@elems/form'
import {mapGetters} from "vuex";
import ItemSubcategories from "./ItemSubcategories";

export default {
    components: {
        InputCheckbox,
        Modal,
        FormField,
        InputTextarea,
        InputText,
        InputDropzone,
        ItemSubcategories,
    },
    props: {
        active: {
            type: Boolean,
            default: false,
        },
        itemCategory: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapGetters([
            'listLocales',
        ]),
        title() {
            return 'Underkategori for: ' + (this.itemCategory ? this.itemCategory.name : '');
        },
    },
    methods: {
        onEditSubcategories(row) {
            this.$emit('edit-subcategories', row);
        },
    },
}
</script>

<style lang="scss" scoped>
.item-category-image {
    img {
        max-height: 200px;
        width: auto;
    }

    &--name {
        margin-top: 0.5rem;
        font-size: 12px;
        font-style: italic;
    }

    &--actions {
        display: flex;
        gap: 1rem;
        margin-top: 0.5rem;
        font-size: 12px;
        font-style: italic;

        &--remove {
            cursor: pointer;
            color: #ff3860;
        }

        &--download {
            cursor: pointer;
        }
    }
}
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}

.customer-details {
    h4 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #bbb;
        margin-bottom: 25px;
        cursor: pointer;

        i {
            transition: transform .3s ease-in-out;
        }
    }

    .column {
        display: none;
    }

    &.open {
        h4 i {
            transform: rotate(.5turn);
        }

        .column {
            display: block;
        }
    }


}

.column {
    padding: 0 0.75rem;
}
</style>
